export default __webpack_public_path__ + "static/media/leo.3ee4bfd8.png";